module.exports = __webpack_public_path__ + "static/media/dom7_2.8aaf9291.jpg";